<!--  Copyright (C) 2018 HTC Global Services, Inc. - All Rights Reserved  -->

<div class="notification-container {{position || 'bottom right'}}">
  <app-notification 
  *ngFor="let notification of notifications.slice(0, 6)" 
  [notification]="notification" (onClose)="close(notification)"></app-notification>
</div>